// import React, { useState, useEffect } from "react";
// import {
//   Container,
//   Card,
//   Row,
//   Col,
//   InputGroup,
//   Form,
//   Table,
//   Stack,
//   Button,
//   Modal,
//   Alert,
// } from "react-bootstrap";
// import axios from "axios";
// import { URL } from "../../config";

// const Services = () => {
//   const [showModal, setShowModal] = useState(false);
//   const [showEditModal, setShowEditModal] = useState(false);

//   const [showDeleteModal, setShowDeleteModal] = useState(false);
//   const [serviceToDelete, setServiceToDelete] = useState(null);

//   const [services, setServices] = useState([]);
//   const [errorMessage, setErrorMessage] = useState("");
//   const [searchTerm, setSearchTerm] = useState("");
//   const [searchResult, setSearchResult] = useState([]);
//   const [editService, setEditService] = useState(null);

//   const [formData, setFormData] = useState({
//     services_name: "",
//     image: null,
//     details: "",
//     active: 1,
//   });

//   useEffect(() => {
//     fetchServices();
//   }, []);

//   const fetchServices = async () => {
//     try {
//       const response = await axios.get(`${URL}/allservices`);
//       setServices(response.data);
//     } catch (error) {
//       console.error("Error fetching services: ", error);
//     }
//   };

//   const handleShow = () => setShowModal(true);
//   const handleClose = () => {
//     setShowModal(false);
//     setShowEditModal(false);
//     setFormData({ services_name: "", image: null, details: "", active: 1 });
//     setErrorMessage("");
//   };

//   const handleEdit = async (Id) => {
//     try {
//       const response = await axios.get(`${URL}/services/${Id}`);
//       setEditService(response.data);
//       // setFormData(response.data);
//       setFormData({
//         services_name: response.data.services_name,
//         image: null,
//         details: response.data.details,
//         active: response.data.active ? 1 : 0,
//       });
//       setShowEditModal(true);
//     } catch (error) {
//       console.error("Error fetching details:", error);
//     }
//   };

//   // const handleDelete = async (Id) => {
//   //     try {
//   //         await axios.delete(`http://localhost:4001/services/${Id}`);
//   //         fetchServices();
//   //         console.log('Deleted successfully');
//   //     } catch (error) {
//   //         console.error('Error deleting:', error);
//   //     }
//   // };

//   const handleDeleteClick = (service) => {
//     setServiceToDelete(service);
//     setShowDeleteModal(true);
//   };

//   // When user confirms deletion:
//   const handleConfirmDelete = async () => {
//     try {
//       await axios.delete(
//         `${URL}/services/${serviceToDelete.Id}`
//       );
//       fetchServices();
//     } catch (error) {
//       console.error("Error deleting:", error);
//     } finally {
//       setShowDeleteModal(false);
//       setServiceToDelete(null);
//     }
//   };

//   // When user cancels:
//   const handleCancelDelete = () => {
//     setShowDeleteModal(false);
//     setServiceToDelete(null);
//   };

//   const handleSearch = (value) => {
//     setSearchTerm(value);
//     const filteredServices = services.filter((service) =>
//       service.services_name.toLowerCase().includes(value.toLowerCase())
//     );
//     setSearchResult(filteredServices);
//   };

//   const handleUpdateService = async () => {
//     try {
//       const updatedFormData = new FormData();
//       updatedFormData.append("services_name", formData.services_name);
//       updatedFormData.append("details", formData.details);
//       updatedFormData.append("active", formData.active ? 1 : 0);
//       if (formData.image) {
//         updatedFormData.append("image", formData.image);
//       }

//       await axios.put(
//         `${URL}/services/${editService.Id}`,
//         updatedFormData,
//         {
//           headers: {
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );

//       fetchServices();
//       setShowEditModal(false);
//       console.log("Service updated successfully");
//     } catch (error) {
//       console.error("Error updating:", error);
//     }
//   };

//   // const handleChange = (e) => {
//   //   const { name, value, files } = e.target;
//   //   if (name === "image") {
//   //     setFormData({ ...formData, [name]: files[0] });
//   //   } else {
//   //     setFormData({ ...formData, [name]: value });
//   //   }
//   // };

//   const handleChange = (e) => {
//     const { name, value, files, type, checked } = e.target;
//     if (name === "image") {
//       setFormData({ ...formData, image: files[0] });
//     } else if (type === "checkbox") {
//       setFormData({ ...formData, [name]: checked ? 1 : 0 });
//     } else {
//       setFormData({ ...formData, [name]: value });
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (Object.values(formData).some((value) => value === "")) {
//       setErrorMessage("Fill up all fields please!");
//       return;
//     }

//     try {
//       const newFormData = new FormData();
//       newFormData.append("services_name", formData.services_name);
//       newFormData.append("image", formData.image);
//       newFormData.append("details", formData.details);
//       newFormData.append("active", formData.active ? 1 : 0);

//       await axios.post(`${URL}/services`, newFormData, {
//         headers: {
//           "Content-Type": "multipart/form-data",
//         },
//       });

//       console.log("Service added successfully");
//       setErrorMessage("Service added successfully");

//       setFormData({ services_name: "", image: null, details: "", active: 1 });
//       fetchServices();
//       handleClose();
//     } catch (error) {
//       console.error("Error!", error);
//     }
//   };

//   return (
//     <>
//       <Container>
//         {errorMessage && <Alert variant="danger">{errorMessage}</Alert>}
//         <Card>
//           {/* <Card.Text
//             className="m-3"
//             style={{ fontSize: "26px", fontWeight: "400" }}
//           >
//             Services
//           </Card.Text> */}

//           <Card.Header className="adminUserorder-header">
//             <h4 className="adminUserorder-title">Services</h4>
//           </Card.Header>

//           <Card.Subtitle className="m-3 mt-0 text-muted">
//             <Row className="justify-content-md-center">
//               <Col lg={10} sm={12}>
//                 <InputGroup>
//                   <Form.Control
//                     placeholder="Service name"
//                     aria-label="searchBar"
//                     aria-describedby="basic-addon2"
//                     value={searchTerm}
//                     onChange={(e) => handleSearch(e.target.value)}
//                   />
//                   <InputGroup.Text
//                     id="basic-addon2"
//                     style={{ fontSize: "smaller" }}
//                   >
//                     search
//                   </InputGroup.Text>
//                 </InputGroup>
//               </Col>
//             </Row>
//           </Card.Subtitle>

//           <div>
//             <Table striped hover size="sm" className="mt-3 table-borderless">
//               <thead>
//                 <tr>
//                   <th
//                     className="text-secondary text-uppercase fw-light"
//                     style={{ fontSize: "smaller", textAlign: "left" }}
//                   >
//                     ID
//                   </th>
//                   <th
//                     className="text-secondary text-uppercase fw-light"
//                     style={{ fontSize: "smaller", textAlign: "left" }}
//                   >
//                     Services
//                   </th>
//                   <th
//                     className="text-secondary text-uppercase fw-light"
//                     style={{ fontSize: "smaller", textAlign: "left" }}
//                   >
//                     Details
//                   </th>

//                   <th
//   className="text-secondary text-uppercase fw-light"
//   style={{ fontSize: "smaller", textAlign: "left" }}
// >
//   Status
// </th>


//                   <th
//                     className="text-secondary text-uppercase fw-light"
//                     style={{ fontSize: "smaller", textAlign: "left" }}
//                   >
//                     Image
//                   </th>
//                   <th
//                     className="text-secondary text-uppercase fw-light"
//                     style={{ fontSize: "smaller", textAlign: "left" }}
//                     colSpan={2}
//                   >
//                     Actions
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {(searchTerm ? searchResult : services).map((data, index) => (
//                   <tr key={index}>
//                     <td className="p-2" style={{ textAlign: "left" }}>
//                       {data.Id}
//                     </td>
//                     <td className="p-2" style={{ textAlign: "left" }}>
//                       {data.services_name}
//                     </td>
//                     <td className="p-2" style={{ textAlign: "left" }}>
//                       {data.details}
//                     </td>

//                     <td className="p-2" style={{ textAlign: "left" }}>
//   <span className={`badge ${data.active ? "bg-success" : "bg-secondary"}`}>
//     {data.active ? "Active" : "Inactive"}
//   </span>
// </td>


//                     <td style={{ textAlign: "left" }}>
//                       <img
//                         src={`${URL}/uploads/${data.image}`}
//                         alt={data.services_name}
//                         width="90"
//                         height="60"
//                         style={{ borderRadius: "50px" }}
//                       />
//                     </td>
//                     <td className="p-2">
//                       <Button
//                         className="m-0 p-0"
//                         variant="none"
//                         onClick={() => handleEdit(data.Id)}
//                       >
//                         <i
//                           className="bi bi-pencil-square"
//                           style={{ color: "blue" }}
//                         ></i>
//                       </Button>
//                     </td>
//                     <td className="p-2">
//                       <Button
//                         className="m-0 p-0"
//                         variant="none"
//                         onClick={() => handleDeleteClick(data)}
//                       >
//                         <i
//                           className="bi bi-trash3-fill"
//                           style={{ color: "red" }}
//                         ></i>
//                       </Button>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </Table>
//           </div>
//         </Card>

//         <Stack direction="horizontal" gap={3} className="mt-3">
//           <div className="p-2 ms-auto">
//             <Button variant="none" onClick={handleShow}>
//               <i
//                 className="bi bi-plus-circle-fill"
//                 style={{ fontSize: "35px" }}
//               ></i>
//             </Button>
//           </div>
//         </Stack>
//       </Container>

//       {/* Add form */}
//       <Modal show={showModal} onHide={handleClose} centered>
//         <Modal.Header closeButton>
//           <Modal.Title className="w-100 text-center fw-bold">
//             Add Service
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form onSubmit={handleSubmit}>
//             <Form.Group controlId="formServiceName">
//               <Form.Label>Service Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 placeholder="Enter service name"
//                 name="services_name"
//                 value={formData.services_name}
//                 onChange={handleChange}
//                 required
//               />
//             </Form.Group>
//             <Form.Group controlId="formServiceDetails">
//               <Form.Label>Details</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 placeholder="Enter service details"
//                 name="details"
//                 value={formData.details}
//                 onChange={handleChange}
//                 required
//               />
//             </Form.Group>

//             <Form.Group controlId="formServiceActive" className="mt-2">
//   <Form.Check
//     type="switch"
//     label="Active"
//     name="active"
//     checked={!!formData.active}
//     onChange={handleChange}
//   />
// </Form.Group>


//             <Form.Group controlId="formServiceImage">
//               <Form.Label>Image</Form.Label>
//               <Form.Control
//                 type="file"
//                 name="image"
//                 onChange={handleChange}
//                 required
//               />
//             </Form.Group>

//             <div className="d-flex justify-content-center">
//               <Button
//                 variant="outline-success"
//                 className="mt-3"
//                 style={{ padding: "10px 20px", borderRadius: "10px" }}
//                 type="submit"
//               >
//                 Submit
//               </Button>
//             </div>
//           </Form>
//         </Modal.Body>
//       </Modal>

//       {/* Edit form */}
//       <Modal show={showEditModal} onHide={handleClose} centered>
//         <Modal.Header closeButton>
//           <Modal.Title className="w-100 text-center fw-bold">
//             Edit Services
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <Form>
//             <Form.Group className="mb-3" controlId="editServiceName">
//               <Form.Label>Service Name</Form.Label>
//               <Form.Control
//                 type="text"
//                 name="services_name"
//                 value={formData.services_name}
//                 onChange={handleChange}
//               />
//             </Form.Group>
//             <Form.Group className="mb-3" controlId="editServiceDetails">
//               <Form.Label>Details</Form.Label>
//               <Form.Control
//                 as="textarea"
//                 name="details"
//                 value={formData.details}
//                 onChange={handleChange}
//               />
//             </Form.Group>

//             <Form.Group className="mb-3" controlId="editServiceActive">
//   <Form.Check
//     type="switch"
//     label="Active"
//     name="active"
//     checked={!!formData.active}
//     onChange={handleChange}
//   />
// </Form.Group>


//             <Form.Group className="mb-3" controlId="editServiceImage">
//               <Form.Label>Image</Form.Label>
//               <Form.Control type="file" name="image" onChange={handleChange} />
//             </Form.Group>
//           </Form>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="primary" onClick={handleUpdateService}>
//             Update
//           </Button>
//         </Modal.Footer>
//       </Modal>

//       {/* Delete Confirmation Modal */}
//       <Modal show={showDeleteModal} onHide={handleCancelDelete} centered>
//         <Modal.Header closeButton>
//           <Modal.Title>Confirm Deletion</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {serviceToDelete && (
//             <p>
//               Are you sure you want to delete “
//               <strong>{serviceToDelete.services_name}</strong>”?
//             </p>
//           )}
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="secondary" onClick={handleCancelDelete}>
//             No, keep it
//           </Button>
//           <Button variant="danger" onClick={handleConfirmDelete}>
//             Yes, delete
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </>
//   );
// };

// export default Services;








// ***** New Update with Auth (1-Dec-2025) ***** //
import React, { useState, useEffect, useCallback } from "react";
import {
  Container,
  Card,
  Row,
  Col,
  InputGroup,
  Form,
  Table,
  Stack,
  Button,
  Modal,
  Alert,
} from "react-bootstrap";
import axios from "axios";
import { URL } from "../../config";

const Services = () => {
  const [showModal, setShowModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [serviceToDelete, setServiceToDelete] = useState(null);

  const [services, setServices] = useState([]);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [editService, setEditService] = useState(null);

  const [formData, setFormData] = useState({
    services_name: "",
    image: null,
    details: "",
    active: 1,
  });

 

  const getAdminHeaders = () => {
    const adminToken = localStorage.getItem("adminToken");
    if (!adminToken) return null;
    return {
      Authorization: `Bearer ${adminToken}`,
    };
  };

  const fetchServices = useCallback(async () => {
    try {
      setErrorMessage("");
      const headers = getAdminHeaders();
      if (!headers) {
        setErrorMessage("Not authorized. Please login as admin.");
        return;
      }

      const response = await axios.get(`${URL}/allservices`, { headers });
      setServices(response.data || []);
      setSearchResult(response.data || []);
    } catch (error) {
      console.error("Error fetching services: ", error);
      if (error.response?.status === 401 || error.response?.status === 403) {
        setErrorMessage("Not authorized. Please login as admin.");
      } else {
        setErrorMessage("Failed to load services.");
      }
    }
  }, []);

  useEffect(() => {
    fetchServices();
  }, [fetchServices]);

  const handleShow = () => {
    setErrorMessage("");
    setSuccessMessage("");
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setShowEditModal(false);
    setFormData({ services_name: "", image: null, details: "", active: 1 });
    setEditService(null);
    setErrorMessage("");
    setSuccessMessage("");
  };

  const handleEdit = async (Id) => {
    try {
      setErrorMessage("");
      setSuccessMessage("");

      const headers = getAdminHeaders();
      if (!headers) {
        setErrorMessage("Not authorized. Please login as admin.");
        return;
      }

      const response = await axios.get(`${URL}/services/${Id}`, { headers });
      setEditService(response.data);

      setFormData({
        services_name: response.data.services_name,
        image: null,
        details: response.data.details,
        active: response.data.active ? 1 : 0,
      });
      setShowEditModal(true);
    } catch (error) {
      console.error("Error fetching details:", error);
      if (error.response?.status === 401 || error.response?.status === 403) {
        setErrorMessage("Not authorized. Please login as admin.");
      } else {
        setErrorMessage("Failed to load service details.");
      }
    }
  };

  const handleDeleteClick = (service) => {
    setErrorMessage("");
    setSuccessMessage("");
    setServiceToDelete(service);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (!serviceToDelete) return;
    try {
      setErrorMessage("");
      setSuccessMessage("");

      const headers = getAdminHeaders();
      if (!headers) {
        setErrorMessage("Not authorized. Please login as admin.");
        return;
      }

      await axios.delete(`${URL}/services/${serviceToDelete.Id}`, {
        headers,
      });

      setSuccessMessage("Service deleted successfully.");
      fetchServices();
    } catch (error) {
      console.error("Error deleting:", error);
      if (error.response?.status === 401 || error.response?.status === 403) {
        setErrorMessage("Not authorized. Please login as admin.");
      } else {
        setErrorMessage("Failed to delete service.");
      }
    } finally {
      setShowDeleteModal(false);
      setServiceToDelete(null);
    }
  };

  const handleCancelDelete = () => {
    setShowDeleteModal(false);
    setServiceToDelete(null);
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
    if (!value.trim()) {
      setSearchResult(services);
      return;
    }
    const filteredServices = services.filter((service) =>
      service.services_name.toLowerCase().includes(value.toLowerCase())
    );
    setSearchResult(filteredServices);
  };

  const handleUpdateService = async () => {
    if (!editService) return;

    try {
      setErrorMessage("");
      setSuccessMessage("");

      const headersBase = getAdminHeaders();
      if (!headersBase) {
        setErrorMessage("Not authorized. Please login as admin.");
        return;
      }

      const updatedFormData = new FormData();
      updatedFormData.append("services_name", formData.services_name);
      updatedFormData.append("details", formData.details);
      updatedFormData.append("active", formData.active ? 1 : 0);
      if (formData.image) {
        updatedFormData.append("image", formData.image);
      }

      await axios.put(`${URL}/services/${editService.Id}`, updatedFormData, {
        headers: {
          ...headersBase,
          "Content-Type": "multipart/form-data",
        },
      });

      setSuccessMessage("Service updated successfully.");
      fetchServices();
      setShowEditModal(false);
    } catch (error) {
      console.error("Error updating:", error);
      if (error.response?.status === 401 || error.response?.status === 403) {
        setErrorMessage("Not authorized. Please login as admin.");
      } else {
        setErrorMessage("Failed to update service.");
      }
    }
  };

  const handleChange = (e) => {
    const { name, value, files, type, checked } = e.target;
    if (name === "image") {
      setFormData({ ...formData, image: files[0] });
    } else if (type === "checkbox") {
      setFormData({ ...formData, [name]: checked ? 1 : 0 });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setErrorMessage("");
    setSuccessMessage("");

    if (
      !formData.services_name ||
      !formData.image ||
      !formData.details
    ) {
      setErrorMessage("Fill up all fields please!");
      return;
    }

    try {
      const headersBase = getAdminHeaders();
      if (!headersBase) {
        setErrorMessage("Not authorized. Please login as admin.");
        return;
      }

      const newFormData = new FormData();
      newFormData.append("services_name", formData.services_name);
      newFormData.append("image", formData.image);
      newFormData.append("details", formData.details);
      newFormData.append("active", formData.active ? 1 : 0);

      await axios.post(`${URL}/services`, newFormData, {
        headers: {
          ...headersBase,
          "Content-Type": "multipart/form-data",
        },
      });

      setSuccessMessage("Service added successfully.");
      setFormData({ services_name: "", image: null, details: "", active: 1 });
      fetchServices();
      handleClose();
    } catch (error) {
      console.error("Error adding service!", error);
      if (error.response?.status === 401 || error.response?.status === 403) {
        setErrorMessage("Not authorized. Please login as admin.");
      } else {
        setErrorMessage("Failed to add service.");
      }
    }
  };

  const listToRender = searchTerm ? searchResult : services;

  return (
    <>
      <Container>
        {errorMessage && (
          <Alert
            variant="danger"
            className="mt-3"
            onClose={() => setErrorMessage("")}
            dismissible
          >
            {errorMessage}
          </Alert>
        )}
        {successMessage && (
          <Alert
            variant="success"
            className="mt-3"
            onClose={() => setSuccessMessage("")}
            dismissible
          >
            {successMessage}
          </Alert>
        )}

        <Card>
          <Card.Header className="adminUserorder-header">
            <h4 className="adminUserorder-title">Services</h4>
          </Card.Header>

          <Card.Subtitle className="m-3 mt-0 text-muted">
            <Row className="justify-content-md-center">
              <Col lg={10} sm={12}>
                <InputGroup>
                  <Form.Control
                    placeholder="Service name"
                    aria-label="searchBar"
                    aria-describedby="basic-addon2"
                    value={searchTerm}
                    onChange={(e) => handleSearch(e.target.value)}
                  />
                  <InputGroup.Text
                    id="basic-addon2"
                    style={{ fontSize: "smaller" }}
                  >
                    search
                  </InputGroup.Text>
                </InputGroup>
              </Col>
            </Row>
          </Card.Subtitle>

          <div>
            <Table striped hover size="sm" className="mt-3 table-borderless">
              <thead>
                <tr>
                  <th
                    className="text-secondary text-uppercase fw-light"
                    style={{ fontSize: "smaller", textAlign: "left" }}
                  >
                    ID
                  </th>
                  <th
                    className="text-secondary text-uppercase fw-light"
                    style={{ fontSize: "smaller", textAlign: "left" }}
                  >
                    Services
                  </th>
                  <th
                    className="text-secondary text-uppercase fw-light"
                    style={{ fontSize: "smaller", textAlign: "left" }}
                  >
                    Details
                  </th>
                  <th
                    className="text-secondary text-uppercase fw-light"
                    style={{ fontSize: "smaller", textAlign: "left" }}
                  >
                    Status
                  </th>
                  <th
                    className="text-secondary text-uppercase fw-light"
                    style={{ fontSize: "smaller", textAlign: "left" }}
                  >
                    Image
                  </th>
                  <th
                    className="text-secondary text-uppercase fw-light"
                    style={{ fontSize: "smaller", textAlign: "left" }}
                    colSpan={2}
                  >
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {listToRender.map((data, index) => (
                  <tr key={index}>
                    <td className="p-2" style={{ textAlign: "left" }}>
                      {data.Id}
                    </td>
                    <td className="p-2" style={{ textAlign: "left" }}>
                      {data.services_name}
                    </td>
                    <td className="p-2" style={{ textAlign: "left" }}>
                      {data.details}
                    </td>
                    <td className="p-2" style={{ textAlign: "left" }}>
                      <span
                        className={`badge ${
                          data.active ? "bg-success" : "bg-secondary"
                        }`}
                      >
                        {data.active ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td style={{ textAlign: "left" }}>
                      <img
                        src={`${URL}/uploads/${data.image}`}
                        alt={data.services_name}
                        width="90"
                        height="60"
                        style={{ borderRadius: "50px" }}
                      />
                    </td>
                    <td className="p-2">
                      <Button
                        className="m-0 p-0"
                        variant="none"
                        onClick={() => handleEdit(data.Id)}
                      >
                        <i
                          className="bi bi-pencil-square"
                          style={{ color: "blue" }}
                        ></i>
                      </Button>
                    </td>
                    <td className="p-2">
                      <Button
                        className="m-0 p-0"
                        variant="none"
                        onClick={() => handleDeleteClick(data)}
                      >
                        <i
                          className="bi bi-trash3-fill"
                          style={{ color: "red" }}
                        ></i>
                      </Button>
                    </td>
                  </tr>
                ))}
                {listToRender.length === 0 && (
                  <tr>
                    <td colSpan={7} className="text-center py-3">
                      No services found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Card>

        <Stack direction="horizontal" gap={3} className="mt-3">
          <div className="p-2 ms-auto">
            <Button variant="none" onClick={handleShow}>
              <i
                className="bi bi-plus-circle-fill"
                style={{ fontSize: "35px" }}
              ></i>
            </Button>
          </div>
        </Stack>
      </Container>

      {/* Add form */}
      <Modal show={showModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center fw-bold">
            Add Service
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group controlId="formServiceName">
              <Form.Label>Service Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter service name"
                name="services_name"
                value={formData.services_name}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Form.Group controlId="formServiceDetails">
              <Form.Label>Details</Form.Label>
              <Form.Control
                as="textarea"
                placeholder="Enter service details"
                name="details"
                value={formData.details}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group controlId="formServiceActive" className="mt-2">
              <Form.Check
                type="switch"
                label="Active"
                name="active"
                checked={!!formData.active}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group controlId="formServiceImage">
              <Form.Label>Image</Form.Label>
              <Form.Control
                type="file"
                name="image"
                onChange={handleChange}
                required
              />
            </Form.Group>

            <div className="d-flex justify-content-center">
              <Button
                variant="outline-success"
                className="mt-3"
                style={{ padding: "10px 20px", borderRadius: "10px" }}
                type="submit"
              >
                Submit
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Edit form */}
      <Modal show={showEditModal} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title className="w-100 text-center fw-bold">
            Edit Services
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3" controlId="editServiceName">
              <Form.Label>Service Name</Form.Label>
              <Form.Control
                type="text"
                name="services_name"
                value={formData.services_name}
                onChange={handleChange}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="editServiceDetails">
              <Form.Label>Details</Form.Label>
              <Form.Control
                as="textarea"
                name="details"
                value={formData.details}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="editServiceActive">
              <Form.Check
                type="switch"
                label="Active"
                name="active"
                checked={!!formData.active}
                onChange={handleChange}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="editServiceImage">
              <Form.Label>Image</Form.Label>
              <Form.Control type="file" name="image" onChange={handleChange} />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleUpdateService}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Delete Confirmation Modal */}
      <Modal show={showDeleteModal} onHide={handleCancelDelete} centered>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {serviceToDelete && (
            <p>
              Are you sure you want to delete “
              <strong>{serviceToDelete.services_name}</strong>”?
            </p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelDelete}>
            No, keep it
          </Button>
          <Button variant="danger" onClick={handleConfirmDelete}>
            Yes, delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Services;
